<template>
  <div class="animated fadeIn container-fluid">
    <h4 v-text="'預警列表 Top 100 Stress Alerts'"></h4>

    <div class="proj-toolbox-area">
      <b-row>
        <b-col md="8">
          <div class="text-center">
            <div aria-describedby="input-live-help">
              <div class="block-text">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>Start Time
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <div>
                    <date-picker
                      v-model="log_start_time"
                      :lang="$tools.lang.date_picker(language)"
                      :width="'100%'"
                      :placeholder="$t('menu.select_date')"
                      :not-after="date_today"
                      format="YYYY-MM-DD HH:mm:ss"
                    ></date-picker>
                  </div>
                </b-input-group>
              </div>
            </div>
            <b-form-text id="input-live-help"
              >從這個日期往後撈預警資料</b-form-text
            >

            <!-- <div class="block-text">Recent Logs</div> -->
            <b-button-group class="block-sm">
              <b-button
                variant="outline-dark"
                :pressed="log_offset == undefined"
                @click="log_offset = undefined"
              >
                1 ~ 100 筆
              </b-button>
              <b-button
                variant="outline-dark"
                :pressed="log_offset == 100"
                @click="log_offset = 100"
              >
                101 ~ 200 筆
              </b-button>
              <b-button
                variant="outline-dark"
                :pressed="log_offset == 200"
                @click="log_offset = 200"
              >
                201 ~ 300 筆
              </b-button>
              <b-button
                variant="outline-dark"
                :pressed="log_offset == 300"
                @click="log_offset = 300"
              >
                301 ~ 400 筆
              </b-button>
              <b-button
                variant="outline-dark"
                :pressed="log_offset == 400"
                @click="log_offset = 400"
              >
                401 ~ 500 筆
              </b-button>
            </b-button-group>
          </div>
        </b-col>
        <b-col md="4">
          <SearchTool
            :list_data="list_logs"
            :search_key="['id', 'device_hash_id', 'status_code']"
            :search_tooltip="''"
            @search-result="search_result = $event"
          ></SearchTool>
        </b-col>
      </b-row>

      <div>
        <b-button
          class="btn-search"
          size="sm"
          v-for="(_code, idx_code) in options_status_codes"
          :key="idx_code"
          :variant="_code.variant"
          :pressed="_code.selected"
          @click="
            _code.selected = !_code.selected;
            selectStatusCode();
          "
          >{{ _code.value }} {{ $t("stress." + _code.value) }}</b-button
        >

        <b-button
          variant="outline-danger"
          size="sm"
          class="btn-search"
          @click="selectStatusCode('all', true)"
          >全選</b-button
        >
        <b-button
          variant="outline-danger"
          size="sm"
          class="btn-search"
          @click="selectStatusCode('all', false)"
          >全不選</b-button
        >
      </div>
      <br />

      <div class="edit-area" v-if="search_result && search_result.length > 0">
        <b-row align-h="center">
          <b-col md="8" class="text-center" v-if="log_range">
            <div v-if="log_range" v-html="log_range"></div>
          </b-col>
        </b-row>
        <div class="list-table-result scroll-style-gray overflow-x">
          <b-table
            hover
            small
            responsive="xl"
            :fields="table_fields"
            :items="table_items"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <!-- A virtual column -->
            <template #cell(status_code)="row">
              <div class="block-text">{{ row.item.status_code }}</div>
              <b-button
                type="button"
                :class="getStressBtnClass(row.item)"
                v-html="getStressBtnText(row.item)"
              >
              </b-button>
            </template>

            <template #cell(cropperiod)="row">
              <div v-if="row.item.cropperiod">
                {{ row.item.cropperiod.name }}
                <div
                  v-if="
                    row.item.cropperiod.project_id != undefined &&
                    row.item.cropperiod.id != undefined
                  "
                  class="detail-title"
                >
                  <i
                    class="fa fa-external-link-square clickable"
                    @click="
                      goToPage(
                        'Cropperiod',
                        {
                          projectID: row.item.cropperiod.project_id,
                          cropperiodID: row.item.cropperiod.id,
                        },
                        true
                      )
                    "
                  ></i>
                </div>
              </div>
            </template>

            <template #cell(details)="row">
              <b-button
                size="sm"
                @click="row.toggleDetails"
                class="mr-2 btn-warning"
              >
                {{ row.detailsShowing ? "Hide" : "Show" }}
              </b-button>
            </template>
            <template #row-details="row">
              <h4>【 預警資訊 】</h4>
              <div>- 發送通知： {{ row.item.is_sent }}</div>
              <br />

              <div v-if="row.item.cropperiod">
                <h4>【 期作資訊 】</h4>
                <div>- 專案 ID： {{ row.item.cropperiod.project_id }}</div>
                <div>- 期作 ID： {{ row.item.cropperiod.id }}</div>
                <div>- 期作名稱： {{ row.item.cropperiod.name }}</div>

                <b-alert
                  v-if="row.item.cropperiod.note"
                  variant="secondary"
                  show
                >
                  <div class="block-text-sm">
                    <i class="icon-menu"></i>{{ $t("menu.admin_note") }}：
                  </div>
                  <div v-html="row.item.cropperiod.note" class="block-sm"></div>
                </b-alert>
              </div>

              <br />
            </template>
          </b-table>

          <!-- 分頁 -->
          <div v-if="perPage">
            <b-pagination
              v-model="currentPage"
              :total-rows="table_items.length"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-else>
        <NoData></NoData>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AgriLoading from "@/views/components/AgriLoading";
import SearchTool from "@/views/components/SearchTool";
import NoData from "@/views/components/NoData";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    AgriLoading,
    SearchTool,
    NoData,
    DatePicker,
  },
  data() {
    return {
      loading_showInfo: false,
      timezone: "Asia/Taipei",
      dateRange: undefined,
      list_logs: [],
      search_result: [],
      log_offset: undefined,
      log_status_codes: [],
      log_start_time: undefined,

      options_status_codes: [],

      // table
      table_items: [],
      currentPage: 1,
      perPage: undefined, //50,
      pageOptions: [
        { value: 10, text: 10 },
        { value: 20, text: 20 },
        { vlaue: 50, text: 50 },
        { value: 100, text: 100 },
        { value: undefined, text: "all" },
      ],
    };
  },
  mounted() {
    this.timezone = this.$tools.date.getTimezoneNow();
    let _yesterday = this.$tools.date.getDateShift(
      this.date_today,
      -1,
      "days",
      "YYYY-MM-DD HH:mm:ss"
    );
    this.log_start_time = _yesterday;

    this.options_status_codes = [];
    this.Admin_Status_Codes.forEach((_code) => {
      this.options_status_codes.push({
        text: this.$t("stress." + _code.value),
        value: _code.value,
        variant: "outline-success",
        selected: false,
      });
    });
    this.Admin_Status_Codes_Global.forEach((_code) => {
      this.options_status_codes.push({
        text: this.$t("stress." + _code.value),
        value: _code.value,
        variant: "outline-info",
        selected: false,
      });
    });

    this.getData_Records();
  },
  computed: {
    ...mapState({
      language: (state) => state.user.language,
      Admin_Status_Codes: (state) => state.standard.const_statusCodes,
      Admin_Status_Codes_Global: (state) =>
        state.standard.const_statusCodes_global,
    }),

    table_fields() {
      return [
        // { key: 'see_user',   sortable: false,    label: undefined },
        { key: "id", sortable: true, label: "預警 ID" },
        { key: "status_code", sortable: true, label: "預警 code" },
        { key: "device_hash_id", sortable: true, label: "裝置 ID" },
        { key: "cropperiod", sortable: true, label: "期作" },
        { key: "log_time", sortable: true, label: "操作時間" },
        { key: "details", sortable: false, label: this.$t("menu.detail") },
      ];
    },

    date_today() {
      if (this.timezone) {
        return this.$tools.date.getDateNow(
          this.timezone,
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      return this.$tools.date.getDateNow("UTC", "YYYY-MM-DD HH:mm:ss");
    },
  },
  watch: {
    search_result(val, oldVal) {
      if (val) {
        this.arrangeTableData();
      }
    },

    log_offset(val, oldVal) {
      this.getData_Records();
    },

    log_start_time(val, oldVal) {
      if (val != undefined) {
        this.log_start_time = val;
        this.getData_Records();
      }
    },
  },
  methods: {
    goToPage: function (name, params = {}, openNewTab = false) {
      this.$tools.ui.goToPage(this.$router, name, params, openNewTab);
    },

    getStressBtnClass(alert) {
      let _defaultClass = "btn-stress btn-stress_";
      return _defaultClass + alert.status_code;
    },

    getStressBtnText(alert) {
      return `<i class="${this.$tools.style.classStressIcon(
        alert.status_code,
        "block-text"
      )}"></i>${this.$t("stress." + alert.status_code)}`;
    },

    selectStatusCode(action = undefined, selected = false) {
      this.log_status_codes = [];
      if (action == "all") {
        if (selected == true) {
          this.options_status_codes.forEach((_code) => {
            _code.selected = true;
            this.log_status_codes.push(_code.value);
          });
        } else {
          this.options_status_codes.forEach((_code) => {
            _code.selected = false;
          });
        }
      } else {
        this.options_status_codes.forEach((_code) => {
          if (_code.selected == true) this.log_status_codes.push(_code.value);
        });
      }
      this.getData_Records();
    },

    getData_Records() {
      this.loading_showInfo = true;
      this.list_logs = [];

      let _start_time = this.$tools.date.dataTimeZone_to_UTC(
        this.log_start_time,
        this.timezone
      );
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Get_Alerts_Top100", {
          offset: this.log_offset,
          start_time: _start_time,
          status_codes:
            this.log_status_codes.length > 0
              ? this.log_status_codes
              : undefined,
        }),
      };
      this.$http(options)
        .then((res) => {
          this.loading_showInfo = false;

          let _all_logs = [];

          if (res.data.stress_alerts) {
            _all_logs = res.data.stress_alerts.slice();

            _all_logs.forEach((_log) => {
              // 時區轉換
              _log.log_time = this.$tools.date.dateTimeZone(
                _log.log_time,
                this.timezone,
                "YYYY-MM-DD HH:mm:ss"
              );
              _log.created_at = this.$tools.date.dateTimeZone(
                _log.created_at,
                this.timezone,
                "YYYY-MM-DD HH:mm:ss"
              );
              _log.updated_at = this.$tools.date.dateTimeZone(
                _log.updated_at,
                this.timezone,
                "YYYY-MM-DD HH:mm:ss"
              );

              if (_log.cropperiod != undefined) {
                _log.cropperiod.start_date = this.$tools.date.dateTimeZone(
                  _log.start_date,
                  this.timezone,
                  "YYYY-MM-DD HH:mm:ss"
                );

                _log.searchValue += " " + _log.cropperiod.name;
                _log.searchValue += " " + _log.cropperiod.farm_field;
                if (_log.cropperiod.note != undefined)
                  _log.searchValue += " " + _log.cropperiod.note;
              }
            });

            if (_all_logs.length > 0) {
              this.log_range = `<span class="err-msg block-text">【 Logs ID：  ${
                _all_logs[0].id
              } ~ ${_all_logs[_all_logs.length - 1].id} 】</span>`;
              this.log_range += ` ${_all_logs[0].log_time} ~ ${
                _all_logs[_all_logs.length - 1].log_time
              }`;
              this.log_range += ` ( ${_all_logs.length} 筆 )`;
            } else this.log_range = undefined;

            /*
                        [{
                            "id":758,
                            "user_id":2,
                            "log_time":"2019-08-27 10:01:12",
                            "type":"write",
                            "ip_address":"36.231.22.99",
                            "detail":{
                                "page":"cropperiod",
                                "action":"reset status",
                                "querySettings":{
                                    "project ID":"3",
                                    "project name":"阿龜辦公室",
                                    "cropperiod ID":8,
                                    "cropperiod name":"一個期作",
                                    "cropperiod status":"done => farming",
                                    "project status":"activate",
                                    "service level":"education"
                                }
                            }
                        }]
                         */
          }
          this.list_logs = _all_logs;
        })
        .catch((err) => {
          this.loading_showInfo = false;
        });
    },

    arrangeTableData() {
      let _items = [];
      this.search_result.forEach((_data, _idx) => {
        let _new_data = this.$tools.data.deepCopy_object(_data); // 複製一份

        _new_data["idx"] = _idx + 1;

        _items.push(_new_data);
      });
      this.table_items = _items;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-area {
  padding: 10px 15px;
}

.detail-key {
  display: inline-block;
  margin-left: 10px;
  color: #257d57;
}
.detail-title {
  display: inline-block;
  margin-left: 10px;
  color: #0086b3;
}
.detail-item {
  display: inline-block;
  margin-left: 10px;
}

.btn-search {
  margin: 5px 10px 5px 0px;
  padding: 5px 10px;
  min-width: 120px;
  font-size: 0.85rem;
}
</style>
